module.exports = __webpack_public_path__ + "media/homepage/research-team-e0a2a732.webp";